module.exports = __webpack_public_path__ + "img/search.9fb841b3.svg";